import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PocDetailsComponent } from './poc-details.component';

const routes: Routes = [{ path: '', component: PocDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PocDetailsRoutingModule {}
